import { Form, Formik } from 'formik';
import { isEmpty, noop } from 'lodash';
import { PropTypes } from 'prop-types';
import { useCallback, useState } from 'react';
import { useRootStore } from '@nandosaus/state-management';

import { Button } from '../button/new';
import { Flex } from '../grid';
import { inputSize } from '../../constants';
import { Modal } from '../modal/new';
import { FormikTextInput } from '../input';

const AddOfferModal = ({ open, handleClose, openOfferModal, onOfferApply }) => {
  const [isLoading, setIsLoading] = useState();
  const { OfferStore, CartStore } = useRootStore();

  const onSubmit = useCallback(
    async ({ promoCode }, { setFieldError }) => {
      setIsLoading(true);
      OfferStore.updatePromoCode(promoCode);
      const unlockedOffer = await OfferStore.checkPromoCode();

      if (!unlockedOffer) {
        setFieldError('promoCode', 'Enter a valid promo code');
      } else if (OfferStore.error) {
        setFieldError('promoCode', 'Error occurred adding promo code');
      } else if (!isEmpty(unlockedOffer.plus)) {
        openOfferModal(unlockedOffer);
      } else {
        CartStore.updateOffer(unlockedOffer);
        onOfferApply(unlockedOffer);
        handleClose(true);
      }

      setIsLoading(false);
    },
    [CartStore, OfferStore, handleClose, onOfferApply, openOfferModal]
  );

  return (
    <Modal modalTitle="Add promo code" hideBottomDecal={false} open={open} handleClose={() => handleClose()}>
      <Flex flexDirection="column">
        <Formik initialValues={{ promoCode: '' }} onSubmit={onSubmit}>
          {() => (
            <Form>
              <Flex flexDirection="column" gap={{ xs: '30px', lg: '36px' }} alignItems="center">
                <Flex width="100%">
                  <FormikTextInput label="Code" name="promoCode" autoFocus maxLength={40} />
                </Flex>

                <Button
                  height={{ _: inputSize.sm, md: inputSize.md, lg: inputSize.lg }}
                  type="submit"
                  size="tall"
                  isLoading={isLoading}
                  disabled={isLoading}
                >
                  ADD CODE
                </Button>
              </Flex>
            </Form>
          )}
        </Formik>
      </Flex>
    </Modal>
  );
};

AddOfferModal.propTypes = {
  open: PropTypes.bool,
  onOfferApply: PropTypes.func,
  openOfferModal: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
};

AddOfferModal.defaultProps = {
  open: false,
  onOfferApply: noop,
  openOfferModal: noop,
};

export { AddOfferModal };
